module.exports = __webpack_public_path__ + "static/img/mallBg.6542255.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mallBg.jpg
// module id = gIwk
// module chunks = 0